<div class="content-area">
  <div class="clr-row">
    <div class="clr-col-12 clr-col-md-8 post-wrapper">
      <div class="featured-image-wrapper"></div>
      <h1 class="text-center">Despre noi</h1>
      <div class="post-content">
        <p>Proiectul FunBible.net s-a născut din pasiune pentru învățarea despre Dumnezeu.</p>
        <p>Credem ca, de multe ori, copiii
          noștri nu primesc stimularea necesară pentru
          a învăța despre Dumnezeu și întâmplările minunate din Biblie.</p>
        <p>Ne dorim ca această platformă sa îi ajute pe părinți să găsească activități și moduri noi
          de a-i învăța pe copii despre lucrurile minunate din Biblie.</p>
        <p class="mt-3">
          <b>
            Dacă vrei să faci parte din acest proiect prin idei, muncă, marketing, grafică sau bani, scrie-ne prin secțiunea
            <a [routerLink]="['/contact']">Contact</a>.
          </b>
        </p>
      </div>
      <h2 class="text-center">Echipă</h2>
      <div class="justify-content-center">
        <carousel height="600" autoplay="true" loop="true">
        <div class="text-center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/radu.jpg" class="circle-image" alt="imagine cu Radu"/>
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Radu Anastase
            </div>
            <div class="staff-title mb-2">
              Creator FunBible.net
            </div>
            <div class="staff-description">
              Tată a doi copii. Soț. Software engineer
            </div>
          </div>
        </div>
        <div class="text center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/dragos.jpg" class="circle-image" alt="imagine cu Dragos"/>
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Dragoș Gârea
            </div>
            <div class="staff-title mb-2">
              Director Grafic FunBible.net
            </div>
            <div class="staff-description">
              Căsătorit. Îi plac: muzica, muntele și pisicile. Graphic designer
            </div>
          </div>
        </div>
        <div class="text-center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/vlad.jpg" class="circle-image" alt="imagine cu Vlad"/>
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Vlad Timotei
            </div>
            <div class="staff-title mb-2">
              Creator de jocuri
            </div>
            <div class="staff-description">
              Un explorator pasionat de provocări și de minunile naturii
            </div>
          </div>
        </div>
        <div class="text-center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/ema.jpg" class="circle-image" alt="imagine cu Emanuela"/>
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Emanuela Gheorghiu
            </div>
            <div class="staff-title mb-2">
              Content Writer / Storyteller
            </div>
            <div class="staff-description">
              Pasionată de arta utilizării cuvintelor pentru a crea frumusețe. Deschisă către diversitate și dialog.
            </div>
          </div>
        </div>
        <div class="text-center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/cosmin.jpg" class="circle-image" alt="imagine cu Cosmin">
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Cosmin Smedia
            </div>
            <div class="staff-title mb-2">
              Junior Front-end Developer
            </div>
            <div class="staff-description">
              Un optimist convins, întotdeauna cu zâmbetul pe buze. 
            </div>
          </div>
        </div>
        <div class="text-center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/laura.jpg" class="circle-image" alt="imagine cu Laura">
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Laura Gârea
            </div>
            <div class="staff-title mb-2">
              Social Media Contributor
            </div>
            <div class="staff-description">
              Soție. Mamă a 2 pisici. Medic rezident. Iubește copiii și drumețiile. 
            </div>
          </div>
        </div>
        <div class="text-center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/florentina.jpeg" class="circle-image" alt="imagine cu Florentina">
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Florentina Moșmanu
            </div>
            <div class="staff-title mb-2">
              Corector
            </div>
            <div class="staff-description">
              Mamă a doi copii minunați. Fire analitică și practică
            </div>
          </div>
        </div>
        <div class="text-center carousel-cell">
          <div class="circle-image-wrapper position-relative">
            <img src="assets/bianca.jpg" class="circle-image" alt="imagine cu Bianca">
          </div>
          <div class="text-box-inline mt-2 p-2">
            <div class="staff-name mb-1">
              Bianca Pîrlitu
            </div>
            <div class="staff-title mb-2">
              Creator conținut
            </div>
            <div class="staff-description">
              Fire creativă, îndemânatică, răbdătoare și atentă la detalii, pun pasiune în tot ceea ce fac cu multă implicare.
            </div>
          </div>
        </div>
        </carousel>
      </div>
    <h2 class="text-center">Susținători</h2>
      <div class="clr-row mb-5 justify-content-center">
        <div class="clr-col-10 clr-col-md-5 mb-5 text-center">
          <a class="text-box-inline mt-2 p-2 d-inline-block sponsor"
             href="https://viatasisanatate.ro"
             target="_blank"
             rel="noopener noreferrer"
          >
            <img src="assets/logo-evs.png" alt="logo al editurii Viata si Sanatate"/>
          </a>
        </div>
      </div>

      <div>
        <disqus [identifier]="'about-page'"></disqus>
      </div>
    </div>
  </div>
</div>
